/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChecklistItem } from './ChecklistItem';
import {
    ChecklistItemFromJSON,
    ChecklistItemFromJSONTyped,
    ChecklistItemToJSON,
} from './ChecklistItem';

/**
 * 
 * @export
 * @interface ChecklistTemplateSection
 */
export interface ChecklistTemplateSection {
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplateSection
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplateSection
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplateSection
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplateSection
     */
    machinePartId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplateSection
     */
    machinePartName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplateSection
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTemplateSection
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ChecklistTemplateSection
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecklistTemplateSection
     */
    orderIndex?: number;
    /**
     * 
     * @type {Array<ChecklistItem>}
     * @memberof ChecklistTemplateSection
     */
    items?: Array<ChecklistItem>;
    /**
     * 
     * @type {Date}
     * @memberof ChecklistTemplateSection
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChecklistTemplateSection
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ChecklistTemplateSection
     */
    active?: boolean;
}

/**
 * Check if a given object implements the ChecklistTemplateSection interface.
 */
export function instanceOfChecklistTemplateSection(value: object): value is ChecklistTemplateSection {
    return true;
}

export function ChecklistTemplateSectionFromJSON(json: any): ChecklistTemplateSection {
    return ChecklistTemplateSectionFromJSONTyped(json, false);
}

export function ChecklistTemplateSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistTemplateSection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'machinePartName': json['machinePartName'] == null ? undefined : json['machinePartName'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'version': json['version'] == null ? undefined : json['version'],
        'orderIndex': json['orderIndex'] == null ? undefined : json['orderIndex'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ChecklistItemFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function ChecklistTemplateSectionToJSON(value?: ChecklistTemplateSection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'templateId': value['templateId'],
        'machinePartId': value['machinePartId'],
        'machinePartName': value['machinePartName'],
        'name': value['name'],
        'description': value['description'],
        'version': value['version'],
        'orderIndex': value['orderIndex'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ChecklistItemToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

